import { Link } from "react-router-dom";
import { GlobalVars } from "../../../state/global/globalVars";
import UilPlus from "@iconscout/react-unicons/icons/uil-plus";
import UilMultiply from "@iconscout/react-unicons/icons/uil-multiply";
import { forwardRef } from "react";

const Button = forwardRef(({ text, onClick, icon, className, disabled, isdefault, ...rest }, ref) => {
    return (
        <button
			ref={ref}
            className={`flex ${icon ? "justify-between" : "justify-center"}
				items-center px-2 py-[9px] text-sm rounded border border-transparent
				${disabled ? "bg-light-6 cursor-defualt text-light-4" :
				`shadow-md bg-light-2 text-light-11 active:bg-light-3 active:ring-0 active:shadow-none hover:bg-cityside-secondary-blue
				hover:shadow-md hover:ring-light-3 hover:ring-1 focus:ring-[1px] focus:ring-light-3 focus:outline-none`
				}
				transition duration-350 ease-in-out ${className}`}
            onClick={onClick}
            disabled={disabled}
			default={isdefault}
            {...rest}
			>
            {text && text}
            {icon && icon}
        </button>
    );
});

export default Button;

export function OutlineButton({ text, onClick, icon, className, disabled, isdefault, ...rest }) {
    return (
        <button
			className={`flex ${icon ? "justify-between" : "justify-center"}
				items-center px-2 py-[9px] shadow-md text-sm rounded border border-light-2
				${disabled ? "bg-light-6 cursor-default" :
				`bg-light-11 text-light-2 active:bg-light-3 active:shadow-none hover:border-light-3 
					hover:shadow-md focus:ring-1 focus:ring-light-3 active:ring-0 hover:ring-[1px]
					hover:ring-light-3 hover:bg-cityside-secondary-blue hover:text-light-11`
				}
				transition duration-350 ease-in-out ${className}`}
            onClick={onClick}
            disabled={disabled}
			default={isdefault}
            {...rest}
			>
            {text && text}
            {icon && icon}
        </button>
    );
}

export function LinkButton({ text, to, icon, className, ...rest }) {
	return (
        <Link
			className={`flex ${icon ? "justify-between" : "justify-center"} items-center px-6 sm:px-2 py-[9px] shadow-md text-sm rounded bg-light-2 text-light-11 active:bg-light-3 active:ring-0 active:shadow-none hover:bg-light-3 hover:shadow-md hover:ring-light-3 hover:ring-1 focus:ring-[1px] focus:ring-light-3 focus:outline-none transition duration-350 ease-in-out ${className}`}
            to={to}
            {...rest}
        >
            {text && text}
            {icon && icon}
        </Link>
    );
}

export function ELinkButton({ text, to, icon, className, ...rest }) {
	return (
		<a
			className={`flex ${icon ? "justify-between" : "justify-center"} items-center px-6 sm:px-2 py-[9px] shadow-md text-sm rounded bg-light-2 text-light-11 active:bg-light-3 active:ring-0 active:shadow-none hover:bg-light-3 hover:shadow-md hover:ring-light-3 hover:ring-1 focus:ring-[1px] focus:ring-light-3 focus:outline-none transition duration-350 ease-in-out ${className}`}
			href={to}
			{...rest}
        >
            {text && text}
            {icon && icon}
        </a>
    );
}

export function AddButton({ onClick, className, isSolid, large, isdefault, title, ...rest }) {
	return (
        <button
			title={title}
			className={`flex items-center justify-center p-[2px] rounded ${isSolid ? "bg-light-2 text-light-11 shadow-md hover:border-light-3" : "text-light-2"} border-2 border-light-2  hover:bg-light-3  active:bg-light-3 focus:outline-none focus:border-light-3 transition duration-350 ease-in-out ${className}`} 
			onClick={onClick} 
			default={isdefault}
			{...rest}
		>
            <UilPlus size={large ? GlobalVars.iconSize.md : GlobalVars.iconSize.xs} />
        </button>
    )
}

export function RemoveButton({ onClick, className, isSolid, large, isdefault, title, ...rest}) {
    return (
        <button
			title={title}
			className={`flex items-center justify-center rounded ${isSolid ? "bg-light-2 text-light-11 shadow-md hover:bg-light-3" : "text-light-2 hover:text-light-3"}  active:text-light-3 border-transparent border-2 focus:border-light-3 focus:outline-none transition duration-350 ease-in-out ${className}`}
			onClick={onClick} 
			default={isdefault}
			{...rest}
		>
            <UilMultiply size={large ? GlobalVars.iconSize.md : GlobalVars.iconSize.xs} />
        </button>
    )
}

/*

Sample Props

text="Add"
onClick={() => console.log("clicked")}
icon={
    <UilSave size={GlobalVars.iconSize.xs} />
}

 */
